export const CustomNumberUtils = () => {
    return {
        isInteger: isInteger
    }
}

function isInteger(value) {
    const num = Number(value);
    return Number.isInteger(num) && !isNaN(num);
}